const BASE_URL = {
  ABOUT: 'https://about.biigbrown.com',
  HOO: 'https://www.houseofooh.com/',
};

export { BASE_URL };
